import { call, put, takeLatest } from 'redux-saga/effects';

import { cancelAppointment, getBooking } from '../../services/API';
import {
  actionTypes,
  cancelRequestFailure,
  cancelRequestSuccess,
  requestFailure,
  requestSuccess,
} from './actions';

function* getData(action) {
  const response = yield call(getBooking, action.payload);
  yield put(
    response.isOk ? requestSuccess(response.data, action.payload) : requestFailure(response.error),
  );
}

function* sendData(action) {
  const response = yield call(cancelAppointment, action.payload);
  yield put(
    response.isOk ? cancelRequestSuccess(action.payload) : cancelRequestFailure(response.error),
  );
}

export default function* appointmentsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.CANCEL_REQUEST_START, sendData);
}
